import * as AdType from 'common/constants/ad-type';
import * as AnalyticsEventType from 'common/constants/analytics-event-type';
import * as VideoPlayerType from 'common/constants/video-player-type';
import { getAnalyticsVideoType, sendVideoEvent, trackMetrics } from 'common/utils/analytics';
import { isFunction, values } from 'lodash';
import { toJS } from 'mobx';


class VideoTracker {

    static getBaseVideoData = (video) => {
        const type = getAnalyticsVideoType(video);
        return Object.assign({}, toJS(video), {
            title: (video.collectionTitle + ':' + video.title),
            contentType: type,
            type
        });
    };

    constructor() {
        /**
         * These events include some additional tracking data
         */
        this.eventHandlers = {
            [AnalyticsEventType.AD_COMPLETE]: this.trackAdComplete,
            [AnalyticsEventType.AD_START]: this.trackAdStart,
            [AnalyticsEventType.VIDEO_PROGRESS]: this.trackVideoProgress,
            [AnalyticsEventType.VIDEO_START]: this.trackVideoStart
        };
    }

    track = (video, type, data, playerType) => {
        if (playerType === VideoPlayerType.ASVP || values(AnalyticsEventType).indexOf(type) === -1) {
            return;
        }
        // If the event type is listed use that method instead...
        if (this.eventHandlers.hasOwnProperty(type) && isFunction(this.eventHandlers[type])) {
            return this.eventHandlers[type](video, data, playerType);
        }
        /// Otherwise send basic video tracking data...
        const trackingData = {
            video: VideoTracker.getBaseVideoData(video)
        };
        if (video.auth) {
            sendVideoEvent(type, Object.assign({}, data, { media: trackingData.video }));
        } else {
            trackMetrics(type, trackingData);
        }
    };

    trackAdComplete = (video, eventData) => {
        const trackingData = {
            video: VideoTracker.getBaseVideoData(video)
        };
        if (video.auth) {
            sendVideoEvent(AnalyticsEventType.AD_COMPLETE, Object.assign({}, eventData, { media: trackingData.video }));
            return;
        }
        switch (eventData.adType) {
            case AdType.VIDEO_MIDROLL:
                trackMetrics(AnalyticsEventType.VIDEO_MIDROLL_COMPLETE, trackingData);
                break;
            case AdType.VIDEO_POSTROLL:
                trackMetrics(AnalyticsEventType.VIDEO_POSTROLL_COMPLETE, trackingData);
                break;
        }
    };

    trackAdStart = (video, eventData) => {
        const trackingData = {
            video: VideoTracker.getBaseVideoData(video)
        };
        if (video.auth) {
            return sendVideoEvent(AnalyticsEventType.AD_START, Object.assign({}, eventData, { media: trackingData.video }));
        }
        switch (eventData.adType) {
            case AdType.VIDEO_PREROLL:
                trackMetrics(AnalyticsEventType.VIDEO_PREROLL, trackingData);
                break;
            case AdType.VIDEO_MIDROLL:
                trackMetrics(AnalyticsEventType.VIDEO_MIDROLL_START, trackingData);
                break;
            case AdType.VIDEO_POSTROLL:
                trackMetrics(AnalyticsEventType.VIDEO_POSTROLL_START, trackingData);
                break;
        }
    };

    trackVideoProgress = (video, eventData) => {
        const trackingData = {
            video: Object.assign(VideoTracker.getBaseVideoData(video), { duration: eventData.playheadTime })
        };
        if (video.auth) {
            sendVideoEvent(AnalyticsEventType.VIDEO_PROGRESS, Object.assign({}, eventData, { media: trackingData.video }));
        } else {
            trackMetrics(AnalyticsEventType.VIDEO_PROGRESS, trackingData);
        }
    };

    trackVideoStart = (video, eventData) => {
        const trackingData = {
            video: Object.assign(VideoTracker.getBaseVideoData(video), { autoplayed: true, duration: eventData.length })
        };
        if (video.auth) {
            sendVideoEvent(AnalyticsEventType.VIDEO_START, Object.assign({}, eventData, { media: trackingData.video }));
        } else {
            trackMetrics(AnalyticsEventType.VIDEO_START, trackingData);
        }
    };

}


export default new VideoTracker();



// WEBPACK FOOTER //
// ./src/common/analytics/video-tracker.js